import React, { useEffect, useState } from "react";
import { useI18n } from "../lib/i18n";

export default function CookieBanner() {
  const { t } = useI18n();
  const [shown, setShown] = useState(false);

  useEffect(() => {
    // Don't show the banner on the telepro portal — authenticated telepros have
    // already accepted via the magic-link contract and the banner blocks the
    // call-status dropdown when a row is at the bottom of the viewport.
    const onTeleproPortal = typeof window !== "undefined" &&
      window.location.pathname.startsWith("/teleprospecteur");
    const onAdmin = typeof window !== "undefined" &&
      window.location.pathname.startsWith("/admin");
    if (!localStorage.getItem("mc68_cookies") && !onTeleproPortal && !onAdmin) setShown(true);
    const reopen = () => setShown(true);
    window.addEventListener("mc68:cookies:reopen", reopen);
    return () => window.removeEventListener("mc68:cookies:reopen", reopen);
  }, []);

  const accept = (level) => {
    localStorage.setItem("mc68_cookies", JSON.stringify({ level, at: Date.now() }));
    setShown(false);
  };

  if (!shown) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-[60] p-4 md:p-6" data-testid="cookie-banner">
      <div className="mx-auto max-w-4xl bg-card border border-border rounded-sm p-6 shadow-lg">
        <div className="grid md:grid-cols-[1fr_auto] gap-6 items-center">
          <div>
            <div className="label-uppercase mb-2">{t.cookies.title}</div>
            <p className="text-sm text-muted-foreground leading-relaxed">{t.cookies.message}</p>
          </div>
          <div className="flex flex-col sm:flex-row gap-2 shrink-0">
            <button
              onClick={() => accept("essential")}
              className="px-4 py-2 text-sm font-semibold border border-border hover:border-foreground transition-colors rounded-sm"
              data-testid="cookies-essential"
            >
              {t.cookies.essential_only}
            </button>
            <button
              onClick={() => accept("all")}
              className="px-4 py-2 text-sm font-semibold bg-primary text-primary-foreground hover:bg-[#0f3d29] hover:text-white transition-colors rounded-sm"
              data-testid="cookies-accept-all"
            >
              {t.cookies.accept_all}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
